import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { type PricePolicyContent } from '../api';
import { PRICE_POLICY_CONTENT_KEY } from './queryKey';
export type UsePricePolicyContentQueryResult = {
  pricePolicyData: PricePolicyContent | undefined;
};
export const usePricePolicyContentQuery = () => {
  const $ = _c(4);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = queryClient.getQueryData([PRICE_POLICY_CONTENT_KEY]);
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pricePolicyData = t0;
  let t1;
  if ($[2] !== pricePolicyData) {
    t1 = {
      pricePolicyData
    };
    $[2] = pricePolicyData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};